import { render } from "./editDeadline.vue?vue&type=template&id=f3fabe8e"
import script from "./editDeadline.vue?vue&type=script&lang=js"
export * from "./editDeadline.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__